module.exports = __webpack_public_path__ + "static/img/s3.5ace341d.png";